import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DashboardDTO } from '../pages/dashboard/dashboard.model';
import { ApiUrlService } from '../shared/services/api-url.service';
import { ApiService } from '../shared/constants/api-services.constant';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private apiUrl: string;

  constructor(
    private readonly http: HttpClient,
    private readonly apiUrlService: ApiUrlService
  ) {
    this.apiUrl = this.apiUrlService.build(ApiService.ProjectProductManagement);
  }

  getDashboardDetails(): Observable<DashboardDTO> {
    return this.http.get<DashboardDTO>(`${this.apiUrl}/dashboard`);
  }
}
